import React, { useEffect, useState } from "react";
import { CampaignCard, HorizontalLine } from "../BookingOverview.styled";
import { Collapse } from "../../../../../Components/Layout";
import { BookingCollapse } from "../utils/BookingCollapse";

import { useTranslation } from "react-i18next";
import { ADD_ON_PRICE } from "../../utils/constants";
import { AddonItem } from "../utils/AddonItem";
import Actions from "../../../../../Actions";
import logger from "../../../../../utils/LoggerFrontend";

const createAnalysisOptions = (t) => ({
  optimize: {
    title: t("Analysis for Conversion Optimization"),
    description: t(
      "Your campaign will be analyzed during its runtime. You will receive tips to improve your conversion."
    ),
    img: "/images/campaign-creation/optimize-conversion.png",
    amount: ADD_ON_PRICE
  },
  feedback: {
    title: t("Analysis of Your Campaign"),
    description: t(
      "After the campaign, the performance will be analyzed. You will receive helpful feedback for the next campaign."
    ),
    img: "/images/campaign-creation/optimize-performance.png",
    amount: ADD_ON_PRICE
  }
});

export const AnalysisSection = ({
  optimizeAnalysisStore,
  feedbackAnalysisStore,
  addOns,
  setAddOns = () => {}
}) => {
  const { t } = useTranslation();
  const [collapse, setCollapse] = useState(true);
  const analysisOptions = createAnalysisOptions(t);

  const [analysisCheck, setAnalysisCheck] = useState({
    optimize: Boolean(optimizeAnalysisStore),
    feedback: Boolean(feedbackAnalysisStore)
  });

  const totalCost =
    (analysisCheck.optimize ? ADD_ON_PRICE : 0) + (analysisCheck.feedback ? ADD_ON_PRICE : 0);

  const handleClick = (event, option) => {
    event.stopPropagation();
    setAnalysisCheck((prevState) => ({
      ...prevState,
      [option]: !prevState[option]
    }));
  };

  useEffect(() => {
    logger.log("BookingOverview:draftSaved:updateVideoReview", "called...", {
      optimizeAnalysis: addOns.optimizeAnalysis,
      feedbackAnalysis: addOns.feedbackAnalysis
    });

    if (
      optimizeAnalysisStore !== addOns.optimizeAnalysis ||
      feedbackAnalysisStore !== addOns.feedbackAnalysis
    ) {
      Actions.campaignCreateUpdateReviewData({
        optimizeAnalysis: addOns.optimizeAnalysis,
        feedbackAnalysis: addOns.feedbackAnalysis
      });
    }
  }, [
    optimizeAnalysisStore,
    feedbackAnalysisStore,
    addOns.optimizeAnalysis,
    addOns.feedbackAnalysis
  ]);

  useEffect(() => {
    setAddOns((prev) => ({
      ...prev,
      optimizeAnalysis: analysisCheck.optimize ? ADD_ON_PRICE : null,
      feedbackAnalysis: analysisCheck.feedback ? ADD_ON_PRICE : null
    }));
  }, [analysisCheck, setAddOns]);

  return (
    <CampaignCard onClick={() => setCollapse(!collapse)}>
      <Collapse
        parent={
          <BookingCollapse
            collapse={collapse}
            title={t("Review Videos")}
            dataTip={t(
              "Performance review of the campaigns takes place after the learning phase, which usually lasts 7 or 10 days depending on the platform. Afterwards, customers receive a video with tips and suggestions for optimization."
            )}
            cost={totalCost !== null ? totalCost : 0}
          />
        }
        show={collapse}
        marginBottom="-20px"
      >
        <AddonItem
          option={{ ...analysisOptions.optimize, check: analysisCheck.optimize }}
          handleClick={(e) => handleClick(e, "optimize")}
          t={t}
        />

        <HorizontalLine />

        <AddonItem
          option={{ ...analysisOptions.feedback, check: analysisCheck.feedback }}
          handleClick={(e) => handleClick(e, "feedback")}
          t={t}
        />
      </Collapse>
    </CampaignCard>
  );
};
